import { TemplateRef } from "@angular/core";
import { Session } from '../../../../shared/model/session.model';
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@ng-bootstrap/ng-bootstrap";
import * as i3 from "@angular/common";
import * as i4 from "../../schedule-session/coach-profile-image/coach-profile-image.component";
import * as i5 from "../../../video-call/in-progress-video-call-indicator/in-progress-video-call-indicator.component";
import * as i6 from "../session-control-dropdown/session-control-dropdown.component";
import * as i7 from "../../../../ng-jhipster/language/jhi-translate.directive";
import * as i8 from "@angular/material/tooltip";
import * as i9 from "@fortawesome/angular-fontawesome";
import * as i10 from "../../../../shared/alert/alert-error.component";
import * as i11 from "../../../../shared/coach-bio/coach-bio.component";
import * as i12 from "@ngx-translate/core";
const _c0 = ["coachBioModal"];
function SessionInfoHeaderComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "session-control-dropdown", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("session", ctx_r0.session);
} }
const _c1 = function (a0, a1) { return { duration: a0, time: a1 }; };
function SessionInfoHeaderComponent_div_5_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 16);
    i0.ɵɵelement(3, "use", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "div", 18);
    i0.ɵɵelement(5, "h5", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngClass", ctx_r5.onActionPlan ? "time-info-action-plan" : "time-info")("translateValues", i0.ɵɵpureFunction2(2, _c1, ctx_r5.session.duration, ctx_r5.sessionStartTime));
} }
const _c2 = function (a0) { return { coach: a0 }; };
function SessionInfoHeaderComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵelement(2, "h4", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, SessionInfoHeaderComponent_div_5_div_3_Template, 6, 5, "div", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r1.onActionPlan ? "coach-info-action-plan" : "coach-info")("translateValues", i0.ɵɵpureFunction1(3, _c2, ctx_r1.session.coach == null ? null : ctx_r1.session.coach.login));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.session.minutesLeftToSessionStart <= 0);
} }
function SessionInfoHeaderComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 21);
    i0.ɵɵelement(3, "use", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("routerLink", "/session/chat/" + ctx_r2.session.id);
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(1, 4, "sessionChat.paragraph.expandInfo"))("matTooltipPosition", "below")("matTooltipClass", "expand-tool-tip");
} }
function SessionInfoHeaderComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "fa-icon", 24);
    i0.ɵɵlistener("click", function SessionInfoHeaderComponent_ng_template_10_Template_fa_icon_click_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.closeAll(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 25);
    i0.ɵɵelement(3, "jhi-alert-error");
    i0.ɵɵelement(4, "coach-bio", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("coach", ctx_r4.coachBioCoach);
} }
export class SessionInfoHeaderComponent {
    constructor(router, modalService) {
        this.router = router;
        this.modalService = modalService;
    }
    ngOnInit() {
        this.url = this.router.url;
    }
    displayCoachBio(coach) {
        this.coachBioCoach = coach;
        this.modalService.open(this.coachBioModal, { size: 'lg', backdrop: 'static', centered: true });
    }
    closeAll() {
        this.modalService.dismissAll();
    }
}
SessionInfoHeaderComponent.ɵfac = function SessionInfoHeaderComponent_Factory(t) { return new (t || SessionInfoHeaderComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i2.NgbModal)); };
SessionInfoHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SessionInfoHeaderComponent, selectors: [["session-info-header"]], viewQuery: function SessionInfoHeaderComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.coachBioModal = _t.first);
    } }, inputs: { session: "session", sessionStartTime: "sessionStartTime", onActionPlan: "onActionPlan", displaySessionInfoHeader: "displaySessionInfoHeader" }, decls: 12, vars: 8, consts: [[4, "ngIf"], [1, "d-flex", "justify-content-between"], [1, "d-flex", "px-3", "flex-row", "align-items-center", "justify-content-start", "p-3"], [1, "mr-3", 2, "min-width", "2rem"], [2, "cursor", "pointer", 3, "coachId", "coachLogin", "click"], [1, "d-flex", "align-items-center", "justify-content-start", "justify-content-xl-end", "px-3", "py-2", "second-line"], ["id", "user-home-expand-chat-btn", "class", "expand-div", 3, "routerLink", "matTooltip", "matTooltipPosition", "matTooltipClass", 4, "ngIf"], [1, "px-3", "py-2", 2, "background-color", "#F8F7F2"], [3, "session", "videoCallIsInProgress"], ["coachBioModal", ""], [3, "session"], [1, "mt-2"], ["jhiTranslate", "sessionChat.header.coach", 3, "ngClass", "translateValues"], ["class", "d-flex", 4, "ngIf"], [1, "d-flex"], [1, "hour-div"], [1, "mb-1", 2, "width", "1rem", "height", "1rem"], [0, "xlink", "href", "../../../../../../../../../../../../content/images/sprite.svg?v=3#hour"], [1, "align-items-center"], ["jhiTranslate", "sessionChat.header.timeInfo", 3, "ngClass", "translateValues"], ["id", "user-home-expand-chat-btn", 1, "expand-div", 3, "routerLink", "matTooltip", "matTooltipPosition", "matTooltipClass"], [1, "expand", 2, "width", "2.6rem!important", "height", "2.6rem!important"], [0, "xlink", "href", "../../../../../../../../../../../../content/images/sprite.svg?v=3#expand"], [1, "olha-theme", "p-4", "coach-bio"], ["icon", "times-circle", 1, "close", 3, "click"], [1, "main-body"], [3, "coach"]], template: function SessionInfoHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SessionInfoHeaderComponent_div_0_Template, 2, 1, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "coach-profile-image", 4);
        i0.ɵɵlistener("click", function SessionInfoHeaderComponent_Template_coach_profile_image_click_4_listener() { return ctx.displayCoachBio(ctx.session.coach); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, SessionInfoHeaderComponent_div_5_Template, 4, 5, "div", 0);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵtemplate(7, SessionInfoHeaderComponent_div_7_Template, 4, 6, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵelementStart(9, "in-progress-video-call-indicator", 8);
        i0.ɵɵlistener("videoCallIsInProgress", function SessionInfoHeaderComponent_Template_in_progress_video_call_indicator_videoCallIsInProgress_9_listener($event) { return ctx.isVideoCallInProgress = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, SessionInfoHeaderComponent_ng_template_10_Template, 5, 1, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.displaySessionInfoHeader);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("coachId", ctx.session.coach.id)("coachLogin", ctx.session.coach.login);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.session);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.url.includes("/index-user"));
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("d-none", !ctx.isVideoCallInProgress);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("session", ctx.session);
    } }, directives: [i3.NgIf, i4.CoachProfileImageComponent, i5.InProgressVideoCallIndicatorComponent, i6.SessionControlDropdownComponent, i7.JhiTranslateDirective, i3.NgClass, i1.RouterLink, i8.MatTooltip, i9.FaIconComponent, i10.AlertErrorComponent, i11.CoachBioComponent], pipes: [i12.TranslatePipe], styles: [".coach-bio[_ngcontent-%COMP%]{min-height:600px;max-height:800px}coach-bio[_ngcontent-%COMP%]{overflow:scroll}.inuka-bird-div[_ngcontent-%COMP%]{background:#fff !important;margin:15px !important;border-radius:50% !important}.inuka-bird-div-action-plan[_ngcontent-%COMP%]{background:#fff !important;margin:5px !important;border-radius:50% !important}.inuka-bird[_ngcontent-%COMP%]{padding:5px !important}.hour-div[_ngcontent-%COMP%]{margin-right:5px !important}h5[_ngcontent-%COMP%]{color:#44a38b !important}h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%]{font-weight:600 !important}.coach-info-action-plan[_ngcontent-%COMP%]{font-size:12px !important}.time-info-action-plan[_ngcontent-%COMP%]{font-size:10px !important}.coach-info[_ngcontent-%COMP%]{font-size:14px !important}.time-info[_ngcontent-%COMP%]{font-size:12px !important}.info-row[_ngcontent-%COMP%]{display:grid;grid-auto-flow:column;padding:10px}.expand-div[_ngcontent-%COMP%]{width:40px !important;height:40px !important;background:#fff !important;border-radius:50% !important;border:none !important;cursor:pointer !important}.expand-div[_ngcontent-%COMP%]:hover{width:40px !important;height:40px !important;background:#44a38b !important;border-radius:50% !important;border:none !important;cursor:pointer !important}.expand[_ngcontent-%COMP%]{padding:11px !important;filter:invert(57%) sepia(63%) saturate(343%) hue-rotate(114deg) brightness(87%) contrast(86%) !important}.expand[_ngcontent-%COMP%]:hover{padding:11px !important;filter:brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(237deg) brightness(107%) contrast(101%) !important} .expand-tool-tip{color:#fff !important;background:#44a38b !important;border:1px solid #44a38b !important;overflow:visible !important}  .expand-tool-tip:before{content:\"\";position:absolute;bottom:100%;left:47%;border-bottom:5px solid #44a38b;border-left:5px solid transparent;border-right:5px solid transparent;z-index:10000}@media(min-width: 576px){.coach-info[_ngcontent-%COMP%]{font-size:16px !important}.time-info[_ngcontent-%COMP%]{font-size:14px !important}}@media(min-width: 1200px){.inuka-bird-div-action-plan[_ngcontent-%COMP%]{margin:15px !important}.coach-info-action-plan[_ngcontent-%COMP%]{font-size:16px !important}.time-info-action-plan[_ngcontent-%COMP%]{font-size:14px !important}}"] });
